import { render, staticRenderFns } from "./m-task-list.vue?vue&type=template&id=5698b842&scoped=true&"
import script from "./m-task-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-task-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-task-list.vue?vue&type=style&index=0&id=5698b842&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698b842",
  null
  
)

export default component.exports